"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValFormInput = void 0;
var template = "<div>\n        <label :for=\"name\" class=\"form-label d-block\">{{\n            internalLabel\n        }}</label>\n        <v-field\n            :name=\"name\"\n            :label=\"internalLabel\"\n            :bail=\"false\"\n            v-model=\"value\"\n            v-slot:default=\"{ meta, field }\"\n            :rules=\"rules\"\n            v-bind=\"$attrs\"\n        >\n            <slot\n                :valid=\"meta.valid && (meta.dirty || meta.touched)\"\n                :in-valid=\"!meta.valid && (meta.dirty || meta.touched)\"\n                :field=\"field\"\n                :meta=\"meta\"\n            >\n                <!-- default slot content -->\n                <textarea\n                    v-if=\"type === 'textarea'\"\n                    :id=\"uniqueName\"\n                    :value=\"value\"\n                    v-bind=\"field\"\n                    class=\"form-control\"\n                    :class=\"{\n                        'is-valid': meta.valid && (meta.dirty || meta.touched),\n                        'is-invalid':\n                            !meta.valid && (meta.dirty || meta.touched)\n                    }\"\n                    :aria-label=\"internalLabel\"\n                    :aria-required=\"ariaRequired\"\n                    :aria-invalid=\"!meta.valid && (meta.dirty || meta.touched)\"\n                 />\n                <select\n                    v-else-if=\"type === 'select'\"\n                    :id=\"uniqueName\"\n                    :value=\"value\"\n                    v-bind=\"field\"\n                    class=\"form-select\"\n                    :class=\"{\n                        'is-valid': meta.valid && (meta.dirty || meta.touched),\n                        'is-invalid':\n                            !meta.valid && (meta.dirty || meta.touched)\n                    }\"\n                    :aria-label=\"internalLabel\"\n                    :aria-required=\"ariaRequired\"\n                    :aria-invalid=\"!meta.valid && (meta.dirty || meta.touched)\"\n                >\n                    <option v-for=\"(option, index) in options\" :key=\"index\" :value=\"option.value\">{{ option.text }}</option>\n                </select>\n                <input\n                    v-else\n                    :id=\"uniqueName\"\n                    :type=\"type\"\n                    :value=\"value\"\n                    v-bind=\"field\"\n                    class=\"form-control\"\n                    :class=\"{\n                        'is-valid': meta.valid && (meta.dirty || meta.touched),\n                        'is-invalid':\n                            !meta.valid && (meta.dirty || meta.touched)\n                    }\"\n                    :aria-label=\"internalLabel\"\n                    :aria-required=\"ariaRequired\"\n                    :aria-invalid=\"!meta.valid && (meta.dirty || meta.touched)\"\n                />\n            </slot>\n        </v-field>\n        <v-error-message\n            as=\"span\"\n            :name=\"uniqueName\"\n            class=\"invalid-feedback\"\n        ></v-error-message>\n    </div>";
var vee_validate_1 = require("vee-validate");
var vue_1 = require("vue");
/**
 * A wrapper for a VeeValidate Field with bootstrap/html5 validity classes
 */
exports.ValFormInput = (0, vue_1.defineComponent)({
    name: "val-form-input",
    template: template,
    components: { "v-field": vee_validate_1.Field, "v-error-message": vee_validate_1.ErrorMessage },
    inheritAttrs: false,
    // see https://v3.vuejs.org/guide/typescript-support.html#annotating-props
    props: {
        /**
         * The html5 input type for the inner element. `select` and `textarea` are also supported. Defaults to text.
         */
        type: { type: String, required: false, default: "text" },
        /**
         * v-model
         */
        modelValue: {
            required: true
        },
        /**
         * The field label
         */
        label: { type: String, required: false, default: "" },
        /**
         * Validation rules for this field
         */
        rules: {
            type: Object,
            required: true
        },
        /**
         * Options array for a select (`{ text: string; value: unknown }[]`)
         */
        options: {
            type: Object,
            default: function () { return []; }
        }
    },
    // see https://v3.vuejs.org/guide/migration/v-model.html#migration-strategy and https://v3.vuejs.org/guide/component-basics.html#using-v-model-on-components
    emits: ["update:modelValue"],
    setup: function (props, context) {
        var uniqueName = (0, vue_1.computed)(function () {
            // use the given name if we have one
            if (context.attrs.name) {
                return context.attrs.name;
            }
            return props.rules.propertyName;
        });
        var internalLabel = (0, vue_1.computed)(function () { return props.label || props.rules.displayName; });
        var value = (0, vue_1.computed)({
            get: function () { return props.modelValue; },
            set: function (value) { return context.emit("update:modelValue", value); }
        });
        return {
            name: context.attrs.name || props.rules.propertyName,
            uniqueName: uniqueName,
            internalLabel: internalLabel,
            value: value,
            ariaRequired: (0, vue_1.computed)(function () {
                return (props.rules.required === true).toString();
            })
        };
    }
});
//# sourceMappingURL=ValFormInput.js.map